"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PriceZoneProductPrice_1 = require("../../../product/model/PriceZoneProductPrice");

var ProductInfo_1 = require("../../../product/model/ProductInfo");

var CompetitorProductDTO_1 = require("./CompetitorProductDTO");
/**
 * Data transfer object describing row in Data pairing page(tab paired and tab recommended),
 *
 * @author RV
 */


var DataPairingProductRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DataPairingProductRowDTO, _DomainObject_1$Domai);

  /**
   *
   * @param purchasePrice
   * @param competitorsProductsDTOs
   * @param productInfo internal product data
   * @param family family name
   * @param prices list of prices for each price zone
   */
  function DataPairingProductRowDTO(purchasePrice, openPurchasePrice) {
    var _this;

    var competitorsProductsDTOs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : immutable_1.List();
    var productInfo = arguments.length > 3 ? arguments[3] : undefined;
    var family = arguments.length > 4 ? arguments[4] : undefined;
    var prices = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, DataPairingProductRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPairingProductRowDTO).call(this));
    _this.purchasePrice = purchasePrice;
    _this.openPurchasePrice = openPurchasePrice;
    _this.competitorsProductsDTOs = competitorsProductsDTOs;
    _this.productInfo = productInfo;
    _this.family = family;
    _this.prices = prices;
    return _this;
  }

  return DataPairingProductRowDTO;
}(DomainObject_1.DomainObject);

exports.DataPairingProductRowDTO = DataPairingProductRowDTO; // tslint:disable-next-line:member-ordering

DataPairingProductRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DataPairingProductRowDTO.name);
  return {
    purchasePrice: builder.bigNum('purchasePrice'),
    openPurchasePrice: builder.opt(builder.bigNum('openPurchasePrice')),
    competitorsProductsDTOs: builder.listOf(builder.obj(CompetitorProductDTO_1.CompetitorProductDTO.name, CompetitorProductDTO_1.CompetitorProductDTO.schema, function (mat) {
      return new CompetitorProductDTO_1.CompetitorProductDTO(mat.ratio, mat.charger, mat.modifiedPrices, mat.competitorReferencePrices, mat.researchType, mat.competitorPrice, mat.competitorProduct, mat.competitorSite, mat.competitor);
    })),
    productInfo: builder.obj(ProductInfo_1.ProductInfo.name, ProductInfo_1.ProductInfo.schema, function (mat) {
      return new ProductInfo_1.ProductInfo(mat.id, mat.externalId, mat.name, mat.familyId, mat.categoryIds, mat.productSensitivityId, mat.tierId, mat.flags, mat.supplierId, mat.measureUnitId, mat.packageSize);
    }),
    family: builder.opt(builder.str('family')),
    prices: builder.listOf(builder.obj('prices', PriceZoneProductPrice_1.PriceZoneProductPrice.schema, function (mat) {
      return new PriceZoneProductPrice_1.PriceZoneProductPrice(mat.priceZoneId, mat.actualRegularPrice, mat.actualMarginPrice, mat.actualMarginPercentage, mat.unitPrice);
    }))
  };
}();